import {LANGS} from 'src/lib/translates/consts'
import type {LangKeyboardsType} from 'entities'

const RU_LETTERS = ['а','б','в','г','д','е','ж',
'з','и','й','к','л','м','н',
'о','п','р','с','т','у','ф',
'х','ц','ч','ш','щ','ъ','ы',
'ь','э','ю','я'];

const RU_LETTERS_KEYBOARD = [
  ['й','ц','у','к','е','н','г','ш','щ','з','х','ъ'],
  ['ф','ы','в','а','п','р','о','л','д','ж','э'],
  ['я','ч','с','м','и','т','ь','б','ю'],
];

const UK_LETTERS = ['а','б','в','г','ґ','д','е',
'є','ж','з','и','і','ї','й',
'к','л','м','н','о','п','р',
'с','т','у','ф','х','ц','ч',
'ш','щ','ь','ю','я'];

const UK_LETTERS_KEYBOARD = [
  ['й','ц','у','к','е','н','г','ш','щ','з','х','ї'],
  ['ф','і','в','а','п','р','о','л','д','ж','є'],
  ['ґ','я','ч','с','м','и','т','ь','б','ю'],
];

const EN_LETTERS = ['a','b','c','d','e','f','g',
'h','i','j','k','l','m','n',
'o','p','q','r','s','t','u',
'v','w','x','y','z'];

const EN_LETTERS_KEYBOARD = [
  ['q','w','e','r','t','y','u','i','o','p'],
  ['a','s','d','f','g','h','j','k','l'],
  ['z','x','c','v','b','n','m'],
];

const TR_LETTERS = [
'a','b','c','ç','d','e','f',
'g','ğ','h','ı','i','j','k',
'l','m','n','o','ö','p','r',
's','ş','t','u','ü','v','y',
'z', 'q', 'w', 'x'];

const TR_LETTERS_KEYBOARD = [
  ['q','w','e','r','t','y','u','ı','o','p','ğ','ü'],
  ['a','s','d','f','g','h','j','k','l','ş','i'],
  ['z','x','c','v','b','n','m','ö','ç'],
];

export const LANG_KEYBOARDS: LangKeyboardsType = {
  [LANGS.RU]: {
    letters: RU_LETTERS,
    keyboardView: RU_LETTERS_KEYBOARD,
  },
  [LANGS.EN]: {
    letters: EN_LETTERS,
    keyboardView: EN_LETTERS_KEYBOARD,
  },
  [LANGS.UK]: {
    letters: UK_LETTERS,
    keyboardView: UK_LETTERS_KEYBOARD,
  },
  [LANGS.TR]: {
    letters: TR_LETTERS,
    keyboardView: TR_LETTERS_KEYBOARD,
  }
}

export const IMGPIXID = 'uef9svubibe87rdvjkdsDdVD'
